
/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import countryCodeChoices from "./countryCodeChoices";

export {
    countryCodeChoices
};
